import React from 'react';
import { cn } from '../../lib/utils';

// Sello Alphatica en la esquina inferior derecha de la foto de producto.
// Debe colocarse dentro de un contenedor con `relative`. Se coloca ANTES de los
// botones que aparecen en hover (p. ej. "Agregar") para que queden por encima.
// El wrapper es un container query (cqw), así el sello escala con el ancho de la foto.
// Fondo blanco translúcido: el sello es tinta oscura y se perdería sobre fotos oscuras.
const SIZES = {
  md: 'clamp(24px, 16cqw, 72px)',
  // Catálogo general (ProductCard): 44% más grande que md (+20% y luego otro +20%)
  catalog: 'clamp(35px, 23cqw, 104px)',
  // Foto grande (detalle de producto): el texto del sello debe alcanzar a leerse
  lg: 'clamp(34px, 28cqw, 157px)',
};

export const ProductStamp = ({ className, size = 'md' }) => (
  <div
    className="absolute inset-0 pointer-events-none select-none"
    style={{ containerType: 'inline-size' }}
    aria-hidden="true"
    data-testid="product-stamp"
  >
    <img
      src="/sello-alphatica.svg"
      alt=""
      draggable={false}
      className={cn('absolute rounded-full bg-white/85 shadow-sm', className)}
      style={{
        right: '4cqw',
        bottom: '4cqw',
        width: SIZES[size] || SIZES.md,
        aspectRatio: '1 / 1',
      }}
    />
  </div>
);
